import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theming/Theming';
import BlogItem from '../Blog/BlogItem';

const CategoriesWrapper = styled.div`
  max-width: 1200px;
  margin: 2rem auto 0;
  width: 100%;
  > h2.title {
    padding: 0 1rem;
    margin-bottom: 1rem;
  }
  > h2,
  > h3,
  > h4,
  > h5 {
    text-align: center;
  }
  .item-list {
    display: flex;
    flex-wrap: wrap;
    ${theme.above.md} {
      margin: 0 -1rem;
    }
    justify-content: center;
  }
  .item-card {
    padding: 1rem 0;
    width: 100%;
    .item-text {
      ${theme.below.sm} {
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }
    ${theme.above.md} {
      width: 50%;
      padding: 1rem;
    }
  }
  ${theme.above.lg} {
    padding: 0 3rem;
  }
`;

export const CategoriesContent = ({
  categories,
  blogPath,
  className,
  title = false,
  subTitle = false,
  ...rest
}) => {
  if (!categories || categories.length === 0 || !blogPath) {
    return null;
  }

  //FILTER OUT BLOG CATEGORIES
  const list = categories.filter(
    (cat) => cat.primaryRoute.path.search(blogPath) !== -1
  );

  if (!list || list.length === 0) {
    return null;
  }

  return (
    <CategoriesWrapper className={className} {...rest}>
      {subTitle && <h3 className="sub-title secondary-font">{subTitle}</h3>}
      {title && <h2 className="title secondary-font">{title}</h2>}
      <div className="item-list">
        {list.map((category, index) => (
          <BlogItem
            category={category}
            key={index}
            index={index}
            className="item-card"
            showReadMore={true}
            productPage={true}
          />
        ))}
      </div>
    </CategoriesWrapper>
  );
};
